import HealthCertificate from "./HealthCertificate";
export default HealthCertificate;